import React from 'react';
import { useSelector } from 'react-redux';
import Team from './Team';
import './TeamList.css';
import ColorLegend from '../planning/ColorLegend';
import * as ResourceStore from '../../store/ResourceStore';
import moment from 'moment';

const CustomTeamList = ({ keyValue = 0, teams = [], currentPadding = 0 }) => {
    const units = useSelector((state) => state[ResourceStore.reducerName].units); 
    const bookings = useSelector((state) => state[ResourceStore.reducerName].bookings);
    const allTeams = useSelector((state) => state.teamState.teams);

    const now = moment();
    const currentBookings = bookings.filter((x) => now.isSameOrAfter(moment(x.startTime)) && now.isSameOrBefore(moment(x.endTime)));

    if(teams.length < 1) return null;

    const addUnits = (team) => {
        if (!team) return;
        const unitsForTeam = currentBookings.reduce((result, b) => {
            if (b.teamId === team.id) {
                const unit = units.find((u) => u.id === b.unitId);
                if (unit) result.push(unit);
            }
            return result;
        }, []);
        return { ...team, units: unitsForTeam };
    };

    const teamsToShow = teams.map(team => {
        const teamObj = allTeams.find(x => x.id === team.id);
        
        // Handle subTeams - convert ID array to team object array
        let subTeams = [];
        if (team.subTeams) {
            subTeams = team.subTeams.map(id => allTeams.find(t => t.id === id)).filter(Boolean);
        } else if (team.subteams) {
            subTeams = team.subteams.map(id => allTeams.find(t => t.id === id)).filter(Boolean);
        }
        
        // Add units to the team if needed (currently commented out)
        // const teamWithUnits = addUnits(teamObj);
        
        return {
            ...team,
            team: teamObj,
            subTeams: subTeams.length > 0 ? subTeams : undefined
        };
    });

    // Group consecutive teams with the same className for special layout
    const groupByClassName = (teams) => {
        const groups = [];
        let currentGroup = [];
        let currentClassName = null;
        
        teams.forEach(team => {
            if (team.className === currentClassName) {
                currentGroup.push(team);
            } else {
                if (currentGroup.length > 0) {
                    groups.push({ className: currentClassName, teams: currentGroup });
                }
                currentClassName = team.className;
                currentGroup = [team];
            }
        });
        
        if (currentGroup.length > 0) {
            groups.push({ className: currentClassName, teams: currentGroup });
        }
        
        return groups;
    };

    const grouped = groupByClassName(teamsToShow);

    const showTeam = (team, isInGroup = false) => {
        if (!team.team) return null;
        
        // If in a grouped container, use 100% width (container has the width)
        const teamWidth = isInGroup ? 100 : (team.width || 100/teamsToShow.length);
        
        return <Team 
            key={team.team.id} 
            team={team.team} 
            width={teamWidth}
            subTeams={team.subTeams}
        />;
    };

    const showGroup = (group) => {
        // If group has className 'subteams-økonomi-kunder-affald', wrap in a column container
        if (group.className === 'subteams-økonomi-kunder-affald') {
            // Use the width from the first team in the group, or calculate default
            const containerWidth = group.teams[0]?.width || 100/teamsToShow.length;
            const containerStyle = { width: containerWidth + '%' };
            
            return (
                <div key={group.className} className="team-column-container" style={containerStyle}>
                    {group.teams.map(team => showTeam(team, true))}
                </div>
            );
        }
        
        // Otherwise render teams normally
        return group.teams.map(team => showTeam(team, false));
    };

    return (
        <div key={keyValue} className="team-list">
            {grouped.map(group => showGroup(group))}
        </div>
    );
};

export default CustomTeamList;